<template>
  <div class="w-full bigContainer">
    <div>
      <h2>{{ $t('message.updateColors.header') }}</h2>
      <div class="container">
        <h1>{{ $t('message.updateColors.title') }}</h1>
        <p>{{ $t('message.updateColors.description') }}</p>
        <div class="w-full">
          <div>
            <h4 class="font-medium">
              {{ $t('message.updateColors.subtitle') }}
            </h4>
            <p>{{ $t('message.updateColors.inputColor1') }}</p>
            <div class="flex">
              <div class="color-pick">
                <input
                  type="color"
                  v-model="color1"
                  @change="
                    updateInputTextValue('color1Input', color1, true, 'color1')
                  "
                  data-vs-input="colorpicker"
                />
              </div>
              <zt-input
                class="ml-4"
                label="Color HEX"
                v-model="color1"
                ref="color1Input"
                outlined
                @change="isValidHexaCode(color1, 'color1')"
                data-vs-input="hexText"
              ></zt-input>
            </div>
            <p class="text-red-500 pt-0 ml-20">
              {{ validations.color1 }}
            </p>
            <p>{{ $t('message.updateColors.inputColor2') }}</p>
            <div class="flex">
              <div class="color-pick">
                <input
                  type="color"
                  v-model="color2"
                  @change="
                    updateInputTextValue('color2Input', color2, true, 'color2')
                  "
                  data-vs-input="colorpicker"
                />
              </div>
              <zt-input
                class="ml-4"
                label="Color HEX"
                v-model="color2"
                ref="color2Input"
                outlined
                @change="isValidHexaCode(color2, 'color2')"
                data-vs-input="hexText"
              />
            </div>
            <p class="text-red-500 pt-0 ml-20">
              {{ validations.color2 }}
            </p>
            <p>{{ $t('message.updateColors.inputColor3') }}</p>
            <div class="flex">
              <div class="color-pick">
                <input
                  type="color"
                  @change="
                    updateInputTextValue('color3Input', color3, true, 'color3')
                  "
                  v-model="color3"
                  data-vs-input="colorpicker"
                />
              </div>
              <zt-input
                class="ml-4"
                label="Color HEX"
                v-model="color3"
                ref="color3Input"
                outlined
                @change="isValidHexaCode(color3, 'color3')"
                data-vs-input="hexText"
              />
            </div>
            <p class="text-red-500 pt-0 ml-20">
              {{ validations.color3 }}
            </p>
            <h4 class="font-medium pt-6">
              {{ $t('message.updateColors.subtitle2') }}
            </h4>
            <p>{{ $t('message.updateColors.inputTitle') }}</p>
            <div class="flex">
              <div class="color-pick">
                <input
                  type="color"
                  v-model="color4"
                  @change="
                    updateInputTextValue('color4Input', color4, true, 'color4')
                  "
                  data-vs-input="colorpicker"
                />
              </div>
              <zt-input
                class="ml-4"
                label="Color HEX"
                v-model="color4"
                ref="color4Input"
                outlined
                @change="isValidHexaCode(color4, 'color4')"
                data-vs-input="hexText"
              />
            </div>
            <p class="text-red-500 pt-0 ml-20">
              {{ validations.color4 }}
            </p>
            <h4 class="font-medium pt-4 mt-4">
              {{ $t('message.updateColors.inconTextTitle') }}
            </h4>
            <p>{{ $t('message.updateColors.iconTextDescription') }}</p>
            <div class="w-full">
              <zt-button
                @click="switchTextColor()"
                :class="{ 'zt-button-outline-primary': !blackText }"
                class="col-6"
                data-vs-button="switchTextColor"
                >{{ $t('message.updateColors.black') }}</zt-button
              >
              <zt-button
                @click="switchTextColor()"
                :class="{ 'zt-button-outline-primary': blackText }"
                class="col-6"
                data-vs-button="switchTextColor"
                >{{ $t('message.updateColors.white') }}</zt-button
              >
            </div>
          </div>
          <h4 class="font-medium">
            {{ $t('message.updateColors.restoreDefault') }}
          </h4>
          <div class="flex">
            <zt-switch
              v-model="restoreDefault"
              @change="restoreDefaultColors(restoreDefault)"
              ref="switchDefault"
              data-vs-switch="restoreDefault"
            />
            <p>{{ $t('message.updateColors.restoreDefaultDescription') }}</p>
          </div>
        </div>
      </div>
      <div class="footer d-flex justify-between">
        <div>
          <zt-button
            color="grey"
            icon="eye"
            class="text-zt-xl preview"
            outlined
            @click="showPreview = true"
            data-vs-button="showPreview"
            >{{ $t('message.updateColors.preview') }}
          </zt-button>
        </div>
        <div>
          <zt-button
            color="disabled"
            data-vs-button="cancel"
            style="color: #707070 !important"
            @click="hasBeenEdited ? (cancelActive = true) : cancel()"
          >
            {{ $t('message.updateColors.cancelButton') }}
          </zt-button>
          <zt-button
            @click="save()"
            data-vs-button="save"
            :disabled="!areColorsValid"
          >
            {{ $t('message.updateColors.saveButton') }}
          </zt-button>
        </div>
      </div>
    </div>
    <zt-modal :active="showModal" @close="showModal = false">
      <template slot="modal-header">
        <div class="p-4 font-medium text-zt-lg">
          <h5>{{ $t('message.updateColors.modalHeader') }}</h5>
        </div>
      </template>
      <div class="modalContainer">
        <div class="svg">
          <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="70"
            height="70"
            viewBox="0 0 70 70"
            style="enable-background: new 0 0 70 70"
            xml:space="preserve"
          >
            <g>
              <circle class="st0" cx="35" cy="35" r="33.3" />
              <path
                class="st1"
                d="M35,69.3C16.1,69.3,0.7,53.9,0.7,35S16.1,0.7,35,0.7S69.3,16.1,69.3,35S53.9,69.3,35,69.3z M35,2.6
							C17.2,2.6,2.6,17.2,2.6,35S17.2,67.4,35,67.4S67.4,52.8,67.4,35S52.8,2.6,35,2.6z"
              />
            </g>
            <path
              class="st2"
              d="M34.7,42.8c-0.9,0-1.7-0.8-1.7-1.7V22.2c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7v18.9
						C36.4,42,35.6,42.8,34.7,42.8z"
            />
            <path
              class="st2"
              d="M34.7,48.2c0.9,0,1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7S33.7,48.2,34.7,48.2z"
            />
          </svg>
        </div>
        <div>
          <h4>{{ $t('message.updateColors.modalTitle') }}</h4>
          <p>{{ $t('message.updateColors.modalText') }}</p>
          <div class="mx-4 items-center mb-8">
            <zt-input
              @keyup.enter="confirm"
              v-model="confirmPassword"
              label="Password"
              type="password"
              outlined
              data-vs-input="confirm_password"
            />
          </div>
          <p v-if="errorModal" class="text-zt-danger text-zt-base">
            {{ errorModal }}
          </p>
        </div>
      </div>
      <template slot="modal-footer">
        <div
          class="zt-modal-footer footer flex justify-center lg:justify-end items-center p-4"
        >
          <zt-button
            @click="showModal = false"
            color="disabled"
            style="color: #707070 !important"
            data-vs-button="modalCancel"
          >
            {{ $t('message.updateColors.cancelButton') }}
          </zt-button>
          <zt-button
            @click="confirm"
            data-vs-button="modalConfirm"
            :disabled="!(confirmPassword.length > 2)"
          >
            {{ $t('message.updateColors.modalConfirm') }}
          </zt-button>
        </div>
      </template>
    </zt-modal>
    <zt-modal
      :active="showPreview"
      @close="showPreview = false"
      max-width="700px"
    >
      <template slot="modal-header">
        <div class="p-4 font-medium text-zt-lg">
          <h5>{{ $t('message.updateColors.previewHeader') }}</h5>
        </div>
      </template>
      <div>
        <template v-if="$store.state.country === 'br'">
          <ColorPreviewPR :colors="colors" />
        </template>
        <template v-else>
          <ColorPreview :colors="colors" />
        </template>
        <div>
          <p v-if="errorModal" class="text-zt-danger text-zt-base">
            {{ errorModal }}
          </p>
        </div>
      </div>
      <template slot="modal-footer">
        <div
          class="zt-modal-footer footer flex justify-center lg:justify-end items-center p-4"
        >
          <zt-button
            @click="showPreview = false"
            class=""
            data-vs-button="closePreview"
          >
            {{ $t('message.updateColors.previewClose') }}
          </zt-button>
        </div>
      </template>
    </zt-modal>
    <zt-modal
      :active="cancelActive"
      class="rounded"
      max-width="43rem"
      @close="cancelActive = false"
    >
      <template slot="modal-header">
        <div class="p-4 font-bold text-zt-lg">
          <h4>{{ $t('message.updateColors.modalReturn.title') }}</h4>
        </div>
      </template>
      <div class="w-full pt-6 flex">
        <div class="w-11/12 mx-auto flex py-4">
          <div class="w-1/5 flex justify-center mt-2">
            <svg
              width="70"
              height="70"
              viewBox="0 0 70 70"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="35"
                cy="35"
                r="34"
                fill="none"
                stroke="#FB8C00"
                stroke-width="2"
              />
              <path
                d="M34.7873 41.3544C33.8465 41.3544 33.0747 40.5825 33.0747 39.6417V20.7913C33.0747 19.8505 33.8465 19.0787 34.7873 19.0787C35.7281 19.0787 36.4999 19.8505 36.4999 20.7913V39.6417C36.4999 40.5858 35.747 41.3544 34.7873 41.3544Z"
                fill="#FB8C00"
                stroke="#FB8C00"
              />
              <path
                d="M34.7873 46.7818C35.7281 46.7818 36.4999 47.5536 36.4999 48.4944C36.4999 49.4352 35.7281 50.207 34.7873 50.207C33.8465 50.207 33.0747 49.4352 33.0747 48.4944C33.0747 47.5536 33.8465 46.7818 34.7873 46.7818Z"
                fill="#FB8C00"
                stroke="#FB8C00"
              />
            </svg>
          </div>
          <div
            class="w-4/5 pt-2 pb-4 flex flex-wrap justify-start items-center px-4"
          >
            <span class="w-full text-zt-xl text-zt-dark-500 font-normal">
              {{ $t('message.updateColors.modalReturn.cancelQuestion') }}
            </span>
            <span class="w-full text-zt-lg text-zt-dark-300 mt-8 font-normal">
              {{ $t('message.updateColors.modalReturn.cancelDataLost') }}
            </span>
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <div
          class="zt-modal-footer flex justify-end items-center p-4 bg-zt-dark-100"
        >
          <div class="w-1/4">
            <zt-button
              @click="cancelActive = false"
              class="ml-1 button-cancel-only-text w-11/12"
              data-vs-button="cancel"
            >
              {{ $t('message.updateColors.modalReturn.cancel') }}
            </zt-button>
          </div>
          <div class="w-1/4">
            <zt-button
              @click="cancel()"
              class="ml-1 w-11/12"
              data-vs-button="return"
            >
              {{ $t('message.updateColors.modalReturn.accept') }}
            </zt-button>
          </div>
        </div>
      </template>
    </zt-modal>
  </div>
</template>

<script>
import User from '../apiClient/User'
import Company from '../apiClient/Company'
import ColorPreview from '@/views/SVG/ColorPreview.vue'
import ColorPreviewPR from '@/views/SVG/ColorPreviewPR.vue'

export default {
  name: 'UpdateColors',
  components: {
    ColorPreview,
    ColorPreviewPR
  },
  data() {
    return {
      color1: '#4F41A3',
      color2: '#DCC1FF',
      color3: '#8672DB',
      color4: '#4F41A3',
      blackText: false,
      restoreDefault: false,
      showModal: false,
      showPreview: false,
      confirmPassword: '',
      errorModal: '',
      error: '',
      cancelActive: false,
      validations: {
        color1: '',
        color2: '',
        color3: '',
        color4: ''
      },
      hasBeenEdited: false
    }
  },
  methods: {
    switchTextColor() {
      this.blackText = !this.blackText
      this.hasBeenEdited = true
      if (this.blackText) {
        this.restoreDefault = false
        this.$refs.switchDefault.checkboxValue = false
      }
    },
    updateInputTextValue(input, value, singleEdit = false, color) {
      this.$refs[input].textFieldValue = value
      if (singleEdit) {
        this.restoreDefault = false
        this.$refs.switchDefault.checkboxValue = false
        this.hasBeenEdited = true
      }
      this.isValidHexaCode(value, color)
    },
    cancel() {
      this.$router.push('/MainBusinessPage')
    },
    save() {
      this.showModal = true
    },
    restoreDefaultColors(val) {
      if (val) {
        const defaultColors = [
          '#4F41A3',
          '#DCC1FF',
          '#8672DB',
          '#4F41A3',
          '#FFFFFF'
        ]
        this.setConfigColors(defaultColors)
        this.hasBeenEdited = true
      }
    },
    async confirm() {
      if (this.confirmPassword.length < 3) return
      if (!this.confirmPassword) return
      const user = new User()
      const valid = await user
        .validPass(this.confirmPassword)
        .then((res) => res)
        .catch((err) => err)
      if (valid.status === 200) {
        const company = new Company()
        await company
          .updateColors(this.colors)
          .then(() => {
            this.$router.push('/MainBusinessPage')
          })
          .catch((error) => {
            error = JSON.parse(JSON.stringify(error))
            this.errorModal = `Error ${error.response.data.code}: ${error.response.data.results.data[0]}`
          })
      } else {
        this.errorModal = this.$t(
          'message.passwordExpired.message_error.error_00034'
        )
      }
    },
    setConfigColors(cssValues) {
      const inputsList = [
        ['color1Input', 'color1'],
        ['color2Input', 'color2'],
        ['color3Input', 'color3'],
        ['color4Input', 'color4']
      ]
      inputsList.forEach((input, index) => {
        this.updateInputTextValue(input[0], cssValues[index], false, input[1])
        this[input[1]] = cssValues[index]
      })
      cssValues[cssValues.length] == '#000000'
        ? (this.blackText = true)
        : (this.blackText = false)
    },
    getCSS() {
      const idEmpresa = this.$store.state.user.empresa.id
      const file = document.createElement('link')
      const random = new Date().getTime()
      file.rel = 'stylesheet'
      file.media = 'screen,print'
      file.href = `${window.sichern.brandingURL}/${idEmpresa}/style.css?${random}`
      document.head.appendChild(file)
      let cssColors = [
        '--branding-primary',
        '--branding-secondary',
        '--branding-activeColor',
        '--branding-titleColor',
        '--branding-textColor'
      ]
      file.onload = () => {
        const cssValues = cssColors.map(
          (Element) =>
            (Element = window
              .getComputedStyle(document.documentElement)
              .getPropertyValue(Element)
              .trim())
        )
        this.setConfigColors(cssValues)
        return cssValues
      }
    },
    isValidHexaCode(str, color) {
      if (str == '')
        return (this.validations[color] = this.$t(
          'message.updateColors.validation.required'
        ))

      if (str[0] != '#')
        return (this.validations[color] = this.$t(
          'message.updateColors.validation.hexFormat'
        ))

      if (!(str.length == 4 || str.length == 7))
        return (this.validations[color] = this.$t(
          'message.updateColors.validation.hexFormat'
        ))

      for (let i = 1; i < str.length; i++)
        if (
          !(
            (str[i].charCodeAt(0) <= '0'.charCodeAt(0) &&
              str[i].charCodeAt(0) <= 9) ||
            (str[i].charCodeAt(0) >= 'a'.charCodeAt(0) &&
              str[i].charCodeAt(0) <= 'f'.charCodeAt(0)) ||
            str[i].charCodeAt(0) >= 'A'.charCodeAt(0) ||
            str[i].charCodeAt(0) <= 'F'.charCodeAt(0)
          )
        )
          return (this.validations[color] = this.$t(
            'message.updateColors.validation.hexFormat'
          ))

      return (this.validations[color] = '')
    }
  },
  computed: {
    colors() {
      let params = {
        primary: this.color1,
        secondary: this.color2,
        activeColor: this.color3,
        titleColor: this.color4,
        textColor: this.blackText ? '#000000' : '#ffffff',
        restoreDefault: this.restoreDefault
      }
      return params
    },
    areColorsValid() {
      return Object.values(this.validations).every((elem) => elem == '')
    }
  },
  created() {
    this.getCSS()
  }
}
</script>

<style scoped lang="scss">
.bigContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .container {
    gap: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 56px 80px;
    width: 660px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
    border-radius: 5px 5px 0px 0px;
    .zt-button-contained:not(.zt-button-outline-primary) {
      background-color: #2d2d2d;
      border-radius: 0 !important;
    }
    .zt-button-outline-primary {
      color: black !important;
      border: 1px solid black;
      border-radius: 0 !important;
    }
  }
  .fa-adjust {
    color: transparent;
    background: linear-gradient(
      to right,
      #4f41a3 0%,
      #4f41a3 50%,
      #898dff 50%,
      #898dff 100%
    );
    border-radius: 50%;
    width: 50px;
    height: 50px;
  }
  h1 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    color: #2d2d2d;
  }
  h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
    color: #707070;
    padding-bottom: 20px;
  }
  h4 {
    font-style: normal;
    font-size: 20px;
    line-height: 30px;
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    padding-bottom: 20px;
    padding-top: 24px;
  }
  .color-pick {
    width: 60px;
    height: 50px;
    overflow: hidden;
    border-radius: 100%;
  }
  input[type='color'] {
    width: 100%;
    height: 100%;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #0000001a;
    transform: scale(1.5);
  }

  .footer {
    text-align: right;
    padding: 17px 24px;
    width: 100%;
    background: #ebebeb;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
    border-radius: 0px 0px 5px 5px;
    .preview {
      font-weight: 500;
      font-size: 14px;
      align-items: center;
      text-align: center;
      color: #707070;
      border: 1px solid #707070 !important;
      padding: 1.35rem !important;
    }
  }
  .zt-modal {
    .modalContainer {
      display: grid;
      grid-template-columns: 90px 1fr;
      h4 {
        padding: 40px 24px 20px 24px;

        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 30px;
        color: #2d2d2d;
      }
      p {
        padding: 0 24px 35px 24px;

        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
      }
      .svg {
        padding: 40px 0 0 27px;
        .st0 {
          fill: #ffffff;
          stroke: #f68c11;
          stroke-width: 0.25;
        }
        .st1 {
          fill: #fb8c00;
          stroke: #f68c11;
          stroke-width: 0.25;
        }
        .st2 {
          fill: #fb8c00;
          stroke: #fb8c00;
        }
      }
    }
  }
}
</style>
